/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_SavingInputs */

const en_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const de_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert...`)
};

const fr_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement...`)
};

const es_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando...`)
};

const it_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio...`)
};

const nl_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan...`)
};

const pl_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisywanie...`)
};

const fi_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallennetaan...`)
};

const da_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemmer...`)
};

const sv_jobs_saving = /** @type {(inputs: Jobs_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparar...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Jobs_SavingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_saving = /** @type {((inputs?: Jobs_SavingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_SavingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_saving(inputs)
	if (locale === "fr") return fr_jobs_saving(inputs)
	if (locale === "es") return es_jobs_saving(inputs)
	if (locale === "it") return it_jobs_saving(inputs)
	if (locale === "nl") return nl_jobs_saving(inputs)
	if (locale === "pl") return pl_jobs_saving(inputs)
	if (locale === "fi") return fi_jobs_saving(inputs)
	if (locale === "da") return da_jobs_saving(inputs)
	if (locale === "sv") return sv_jobs_saving(inputs)
	return en_jobs_saving(inputs)
});